const defaultState = {
  showDamagePrameterTable: false,
  isDamageParameterExpanded: false,
  specificDamageParameterId: undefined,
}

const damageParameter = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_SHOW_DAMAGE_PARAMETER_TABLE':
      return {
        ...state,
        showDamagePrameterTable: action.payload,
      }
    case 'SET_DAMAGE_PARAMETER_EXPANDED_STATUS':
      return {
        ...state,
        isDamageParameterExpanded: action.payload,
      }
    case 'SET_SPECIFIC_DAMAGE_PARAMETER_ID': 
      return {
        ...state,
        specificDamageParameterId: action.payload,
      }
    default: 
      return state
  }
}

export default damageParameter;